var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select-field",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: _vm.$t("pages.orders.type_delivery"),
            id: _vm.id,
            form: _vm.form,
            name: _vm.name,
            multiple: _vm.multiple,
            label: _vm.optionLabel,
            options: _vm.options,
            required: _vm.required,
          },
          on: { search: _vm.onSearch },
        },
        "select-field",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }